<template>
  <component
    :is="annotatorImplementation"
    v-if="annotatorImplementation"
    v-bind="$attrs"
    :content="props.content"
    @highlightsRendered="emit('highlightsRendered')"
  >
    <slot />
  </component>
  <div v-else v-bind="$attrs" class="highlights-content prevent-content-drag">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, shallowRef, type Component } from 'vue'

import type { ContentView } from '@/models/doc'
import { annotatorRewrite18170Experiment } from '@/services/ab'
import { Sentry } from '@/services/sentry'

defineOptions({
  name: 'AnnotatorHost18170',
  inheritAttrs: false,
})

const props = defineProps<{
  content: ContentView
}>()

const emit = defineEmits<{
  (event: 'highlightsRendered'): void
  (event: 'loaded'): void
}>()

const annotatorImplementation = shallowRef<Component | null>(null)

onMounted(async () => {
  annotatorImplementation.value = await loadAnnotatorImplementation()
  await nextTick()
  emit('loaded')
})

async function loadAnnotatorImplementation(): Promise<Component> {
  try {
    if ((await annotatorRewrite18170Experiment()) === 'B') {
      return (await import('./AnnotatorRewrite.vue')).default
    }
  } catch (error) {
    Sentry.captureException(error)
  }

  return (await import('./Annotator.vue')).default
}
</script>
